/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetBrandDto } from './GetBrandDto';
import {
    GetBrandDtoFromJSON,
    GetBrandDtoFromJSONTyped,
    GetBrandDtoToJSON,
} from './GetBrandDto';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';
import type { GetEmployeeDto } from './GetEmployeeDto';
import {
    GetEmployeeDtoFromJSON,
    GetEmployeeDtoFromJSONTyped,
    GetEmployeeDtoToJSON,
} from './GetEmployeeDto';
import type { GetEstimateByMonthDto } from './GetEstimateByMonthDto';
import {
    GetEstimateByMonthDtoFromJSON,
    GetEstimateByMonthDtoFromJSONTyped,
    GetEstimateByMonthDtoToJSON,
} from './GetEstimateByMonthDto';
import type { GetProjectCountryDto } from './GetProjectCountryDto';
import {
    GetProjectCountryDtoFromJSON,
    GetProjectCountryDtoFromJSONTyped,
    GetProjectCountryDtoToJSON,
} from './GetProjectCountryDto';
import type { GetProjectDto } from './GetProjectDto';
import {
    GetProjectDtoFromJSON,
    GetProjectDtoFromJSONTyped,
    GetProjectDtoToJSON,
} from './GetProjectDto';
import type { GetProjectPathPhaseDto } from './GetProjectPathPhaseDto';
import {
    GetProjectPathPhaseDtoFromJSON,
    GetProjectPathPhaseDtoFromJSONTyped,
    GetProjectPathPhaseDtoToJSON,
} from './GetProjectPathPhaseDto';
import type { GetProjectTeamDto } from './GetProjectTeamDto';
import {
    GetProjectTeamDtoFromJSON,
    GetProjectTeamDtoFromJSONTyped,
    GetProjectTeamDtoToJSON,
} from './GetProjectTeamDto';
import type { GetPurchaserDto } from './GetPurchaserDto';
import {
    GetPurchaserDtoFromJSON,
    GetPurchaserDtoFromJSONTyped,
    GetPurchaserDtoToJSON,
} from './GetPurchaserDto';

/**
 * 
 * @export
 * @interface GetProjectWithPurchaseInvoicesDto
 */
export interface GetProjectWithPurchaseInvoicesDto {
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    systemNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    notes: string;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    delayMessage: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    delayVerification: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    endDate: Date;
    /**
     * 
     * @type {GetPurchaserDto}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    purchaser: GetPurchaserDto;
    /**
     * 
     * @type {GetBrandDto}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    brand: GetBrandDto;
    /**
     * 
     * @type {GetProjectDto}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    parent: GetProjectDto;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    active: boolean;
    /**
     * 
     * @type {Array<GetProjectTeamDto>}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    projectTeams?: Array<GetProjectTeamDto>;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    rejectedNote: string;
    /**
     * 
     * @type {Array<GetProjectCountryDto>}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    projectCountries?: Array<GetProjectCountryDto>;
    /**
     * 
     * @type {Array<GetProjectPathPhaseDto>}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    projectPathPhases?: Array<GetProjectPathPhaseDto>;
    /**
     * 
     * @type {number}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    totalDifference: number;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    responsibleOwner: GetEmployeeDto;
    /**
     * 
     * @type {Array<GetEstimateByMonthDto>}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    estimatesByMonths?: Array<GetEstimateByMonthDto>;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    purchaserDocNumber: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    labelDictionary: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    cancelMessage: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    cancelVerification: boolean;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    cancelRequestedByEmployee: GetEmployeeDto;
    /**
     * 
     * @type {Date}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    newStartDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    newEndDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    dateChangeVerification: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    dateChangeMessage: string;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    dateChangeRejectedNote?: string;
    /**
     * 
     * @type {GetEmployeeDto}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    dateChangeRequestedByEmployee: GetEmployeeDto;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    dateChangeRequestedByEmployeeId: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    dateChangeEmailSent: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    purchaseNetTotal: string;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    purchaseInvoicesSum: string;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    purchaseInvoiceRemainingSum: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    hasRights?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    projectPurchaseInvoicesAmountSum?: string;
    /**
     * 
     * @type {string}
     * @memberof GetProjectWithPurchaseInvoicesDto
     */
    projectPurchaseInvoicesAmountWithoutPositionSum?: string;
}

/**
 * Check if a given object implements the GetProjectWithPurchaseInvoicesDto interface.
 */
export function instanceOfGetProjectWithPurchaseInvoicesDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "systemNumber" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "notes" in value;
    isInstance = isInstance && "delayMessage" in value;
    isInstance = isInstance && "delayVerification" in value;
    isInstance = isInstance && "startDate" in value;
    isInstance = isInstance && "endDate" in value;
    isInstance = isInstance && "purchaser" in value;
    isInstance = isInstance && "brand" in value;
    isInstance = isInstance && "parent" in value;
    isInstance = isInstance && "company" in value;
    isInstance = isInstance && "active" in value;
    isInstance = isInstance && "rejectedNote" in value;
    isInstance = isInstance && "totalDifference" in value;
    isInstance = isInstance && "responsibleOwner" in value;
    isInstance = isInstance && "purchaserDocNumber" in value;
    isInstance = isInstance && "labelDictionary" in value;
    isInstance = isInstance && "cancelMessage" in value;
    isInstance = isInstance && "cancelVerification" in value;
    isInstance = isInstance && "cancelRequestedByEmployee" in value;
    isInstance = isInstance && "dateChangeVerification" in value;
    isInstance = isInstance && "dateChangeMessage" in value;
    isInstance = isInstance && "dateChangeRequestedByEmployee" in value;
    isInstance = isInstance && "dateChangeRequestedByEmployeeId" in value;
    isInstance = isInstance && "dateChangeEmailSent" in value;
    isInstance = isInstance && "purchaseNetTotal" in value;
    isInstance = isInstance && "purchaseInvoicesSum" in value;
    isInstance = isInstance && "purchaseInvoiceRemainingSum" in value;

    return isInstance;
}

export function GetProjectWithPurchaseInvoicesDtoFromJSON(json: any): GetProjectWithPurchaseInvoicesDto {
    return GetProjectWithPurchaseInvoicesDtoFromJSONTyped(json, false);
}

export function GetProjectWithPurchaseInvoicesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProjectWithPurchaseInvoicesDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'systemNumber': json['systemNumber'],
        'name': json['name'],
        'number': json['number'],
        'notes': json['notes'],
        'delayMessage': json['delayMessage'],
        'delayVerification': json['delayVerification'],
        'startDate': (new Date(json['startDate'])),
        'endDate': (new Date(json['endDate'])),
        'purchaser': GetPurchaserDtoFromJSON(json['purchaser']),
        'brand': GetBrandDtoFromJSON(json['brand']),
        'parent': GetProjectDtoFromJSON(json['parent']),
        'company': GetCompanyDtoFromJSON(json['company']),
        'active': json['active'],
        'projectTeams': !exists(json, 'projectTeams') ? undefined : ((json['projectTeams'] as Array<any>).map(GetProjectTeamDtoFromJSON)),
        'rejectedNote': json['rejectedNote'],
        'projectCountries': !exists(json, 'projectCountries') ? undefined : ((json['projectCountries'] as Array<any>).map(GetProjectCountryDtoFromJSON)),
        'projectPathPhases': !exists(json, 'projectPathPhases') ? undefined : ((json['projectPathPhases'] as Array<any>).map(GetProjectPathPhaseDtoFromJSON)),
        'totalDifference': json['totalDifference'],
        'responsibleOwner': GetEmployeeDtoFromJSON(json['responsibleOwner']),
        'estimatesByMonths': !exists(json, 'estimatesByMonths') ? undefined : ((json['estimatesByMonths'] as Array<any>).map(GetEstimateByMonthDtoFromJSON)),
        'purchaserDocNumber': json['purchaserDocNumber'],
        'labelDictionary': GetDictionaryDtoFromJSON(json['labelDictionary']),
        'cancelMessage': json['cancelMessage'],
        'cancelVerification': json['cancelVerification'],
        'cancelRequestedByEmployee': GetEmployeeDtoFromJSON(json['cancelRequestedByEmployee']),
        'newStartDate': !exists(json, 'newStartDate') ? undefined : (new Date(json['newStartDate'])),
        'newEndDate': !exists(json, 'newEndDate') ? undefined : (new Date(json['newEndDate'])),
        'dateChangeVerification': json['dateChangeVerification'],
        'dateChangeMessage': json['dateChangeMessage'],
        'dateChangeRejectedNote': !exists(json, 'dateChangeRejectedNote') ? undefined : json['dateChangeRejectedNote'],
        'dateChangeRequestedByEmployee': GetEmployeeDtoFromJSON(json['dateChangeRequestedByEmployee']),
        'dateChangeRequestedByEmployeeId': json['dateChangeRequestedByEmployeeId'],
        'dateChangeEmailSent': json['dateChangeEmailSent'],
        'purchaseNetTotal': json['purchaseNetTotal'],
        'purchaseInvoicesSum': json['purchaseInvoicesSum'],
        'purchaseInvoiceRemainingSum': json['purchaseInvoiceRemainingSum'],
        'hasRights': !exists(json, 'hasRights') ? undefined : json['hasRights'],
        'projectPurchaseInvoicesAmountSum': !exists(json, 'projectPurchaseInvoicesAmountSum') ? undefined : json['projectPurchaseInvoicesAmountSum'],
        'projectPurchaseInvoicesAmountWithoutPositionSum': !exists(json, 'projectPurchaseInvoicesAmountWithoutPositionSum') ? undefined : json['projectPurchaseInvoicesAmountWithoutPositionSum'],
    };
}

export function GetProjectWithPurchaseInvoicesDtoToJSON(value?: GetProjectWithPurchaseInvoicesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'systemNumber': value.systemNumber,
        'name': value.name,
        'number': value.number,
        'notes': value.notes,
        'delayMessage': value.delayMessage,
        'delayVerification': value.delayVerification,
        'startDate': (value.startDate.toISOString()),
        'endDate': (value.endDate.toISOString()),
        'purchaser': GetPurchaserDtoToJSON(value.purchaser),
        'brand': GetBrandDtoToJSON(value.brand),
        'parent': GetProjectDtoToJSON(value.parent),
        'company': GetCompanyDtoToJSON(value.company),
        'active': value.active,
        'projectTeams': value.projectTeams === undefined ? undefined : ((value.projectTeams as Array<any>).map(GetProjectTeamDtoToJSON)),
        'rejectedNote': value.rejectedNote,
        'projectCountries': value.projectCountries === undefined ? undefined : ((value.projectCountries as Array<any>).map(GetProjectCountryDtoToJSON)),
        'projectPathPhases': value.projectPathPhases === undefined ? undefined : ((value.projectPathPhases as Array<any>).map(GetProjectPathPhaseDtoToJSON)),
        'totalDifference': value.totalDifference,
        'responsibleOwner': GetEmployeeDtoToJSON(value.responsibleOwner),
        'estimatesByMonths': value.estimatesByMonths === undefined ? undefined : ((value.estimatesByMonths as Array<any>).map(GetEstimateByMonthDtoToJSON)),
        'purchaserDocNumber': value.purchaserDocNumber,
        'labelDictionary': GetDictionaryDtoToJSON(value.labelDictionary),
        'cancelMessage': value.cancelMessage,
        'cancelVerification': value.cancelVerification,
        'cancelRequestedByEmployee': GetEmployeeDtoToJSON(value.cancelRequestedByEmployee),
        'newStartDate': value.newStartDate === undefined ? undefined : (value.newStartDate.toISOString()),
        'newEndDate': value.newEndDate === undefined ? undefined : (value.newEndDate.toISOString()),
        'dateChangeVerification': value.dateChangeVerification,
        'dateChangeMessage': value.dateChangeMessage,
        'dateChangeRejectedNote': value.dateChangeRejectedNote,
        'dateChangeRequestedByEmployee': GetEmployeeDtoToJSON(value.dateChangeRequestedByEmployee),
        'dateChangeRequestedByEmployeeId': value.dateChangeRequestedByEmployeeId,
        'dateChangeEmailSent': value.dateChangeEmailSent,
        'purchaseNetTotal': value.purchaseNetTotal,
        'purchaseInvoicesSum': value.purchaseInvoicesSum,
        'purchaseInvoiceRemainingSum': value.purchaseInvoiceRemainingSum,
        'hasRights': value.hasRights,
        'projectPurchaseInvoicesAmountSum': value.projectPurchaseInvoicesAmountSum,
        'projectPurchaseInvoicesAmountWithoutPositionSum': value.projectPurchaseInvoicesAmountWithoutPositionSum,
    };
}

